export default {
  type: "string",
  enum: [
    "documents",
    "media",
    "ekultur"
  ]
}